export default [
  {
    path: "/strategy-chart",
    name: "StrategyChart",
    component: () => import(/* webpackChunkName: "strategy_chart" */ "./pages/strategy-chart.component.vue"),
  },
  {
    path: "/portfolio-chart",
    name: "PortfolioChart",
    component: () => import(/* webpackChunkName: "portfolio_chart" */ "./pages/portfolio-chart.component.vue"),
  },
];
